<template>
	<section>
		<header-simple :title="$t('labels.profile.contacts')" :subtitle="$t('Personal information about the patient.')">
			<action-button @click="addContact" :title="$t('Add contact')" />
		</header-simple>

		<grid>
			<grid-item ref="list" v-for="contact in getContacts(patient)" :key="contact.id" :loading="contactLoading.find(e => e.id ==contact.id) != undefined" :title="contact.type" :value="contact.contact">
				<action-group>
					<action-group-item-button @click="editContact(contact)" :title="$t('buttons.general.edit')" />
					<action-group-item-button @click="copyContact(contact)" :title="$t('Copy')" />
					<action-group-item-button @click="deleteContact(contact)" :title="$t('buttons.general.delete')" />
				</action-group>
			</grid-item>
		</grid>

		<watch-profile-contacts-form v-if="modalContactForm.open" :params="modalContactForm.params" :user_uid="user_uid" :watch_id="watch_id" @close="closeModal('modalContactForm', arguments)"/>
	</section>
</template>

<script>
import ActionGroup from '@/modules/ui/ActionGroup'
import ActionGroupItemButton from '@/modules/ui/ActionGroupItemButton'
import HeaderSimple from '@/modules/ui/HeaderSimple'
import ActionButton from '@/modules/ui/ActionButton'
import Grid from '@/modules/ui/Grid'
import GridItem from '@/modules/ui/GridItem'
import { mapGetters, mapActions } from 'vuex'
import WatchProfileContactsForm from '@/components/watch/profile/watchProfile/WatchProfileContactsForm'
export default {
	name: 'watch-profile-contacts',
	props: [
		'user_uid',
		'watch_id'
	],
	components: {
		ActionGroup,
		ActionGroupItemButton,
		HeaderSimple,
		ActionButton,
		WatchProfileContactsForm,
		Grid,
		GridItem
	},
	data() {
		return {
			patient: {},
			contacts: [],
			contactLoading: [],
			modalContactForm: {
				open: false,
				params: {}
			}
		}
	},
	methods: {
		openModal (modal, params = {}) {
			this[modal].open = true
			this[modal].params = params
		},
		closeModal (modal, args) {
			this[modal].open = false
			this[modal].params = {}
		},
		addContact () {
			this.openModal('modalContactForm', { action: 'add' })
		},
		editContact (contact) {
			const id = contact.id
			this.openModal('modalContactForm', { action: 'edit', id })
		},
		copyContact (contact) {
			const id = contact.id
			const dummyId = "contact_id_"+ id
			const dummy = document.createElement("input")

			document.body.appendChild(dummy)
			dummy.setAttribute("id", dummyId)
			document.getElementById(dummyId).value = contact.contact
			dummy.select()
			dummy.setSelectionRange(0, 99999)
			document.execCommand("copy")
			document.body.removeChild(dummy)

			this.$root.$emit('add-floating-box', { type: 'info', title: 'Copy', message: 'Contact copy to clipboard with success.' })
		},
		async deleteContact(contact) {
			if (confirm('Delete?')) {
				this.contactLoading.push(contact)
				try
				{
					await this.contactDelete({ refThis: this, contact })
					this.$root.$emit('add-floating-box', { type: 'success', title: 'Success', message: 'Contact delete with success.' })
				}
				catch (ex)
				{
					this.$root.$emit('add-floating-box', { type: 'error', title: 'Error', message: 'Issue when try to delete contact. Try again please.' })
				}
				this.contactLoading = this.contactLoading.filter(item => item.id !== contact.id)
			}
		},
		...mapActions({
			contactDelete: 'CONTACT_DELETE'
		})
	},
	computed: {
		...mapGetters({
			getPatient: 'PATIENT',
			getContacts: 'PATIENTS_CONTACTS'
		})
	},
	created () {
		this.patient = this.getPatient(parseInt(this.watch_id))
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/watch/profile/watchProfile/WatchProfileContacts.vue